import React from 'react';
import classnames from 'classnames';
import { Spin } from 'antd';
import './styles.less';

const Loading = ( { label, background = true, size = 'large', className } ) => {

    const classes = classnames( [
        'loading',
        { 'loading-with-background': background },
        { [ className ]: Boolean( className ) },
    ] );

    return <div className={ classes }>
        <div className={ `spinner spinner-size-${ size }` }>
            <Spin size={ size } />
            <p>{ label }</p>
        </div>
    </div>;
};

export default Loading;
